import { Shark, Utils, View } from "shark-mvc";

import ImageContent from "../../models/ImageContent";
import PlaceContent from "../../models/PlaceContent";
import TextContent from "../../models/TextContent";

import templateContent from "./dashboard.html";

import contentFinderComponent from "../../components/contentFinder/contentFinderComponent";
import imageContentManager from "../../controllers/imageContentManager";
import imageContentView from "../imageContent/imageContentView";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import newContentTypeModalComponent from "../../components/newContentTypeModal/newContentTypeModalComponent";
import placeContentManager from "../../controllers/placeContentManager";
import placeContentView from "../placeContent/placeContentView";
import textContentManager from "../../controllers/textContentManager";
import textContentView from "../textContent/textContentView";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";

class DashboardView extends View {
	recentRange = {
		first: 0,
		length: 5,
	};

	recentSort = {
		updated_at: "DESC",
	};

	constructor () {
		super("dashboardView");

		this.$mainRoute = "dashboard";
		this.setTemplate(templateContent);
	}

	beforeLoad () {
		window.scrollTo(0, 0);

		// contentFinderComponent.on("content_selected", this.contentFinderComponent_content_selectedHandler);

		let currUser = Shark.get("currUser");

		if (currUser) {
			this.refreshRecentImageContentList();
			this.refreshRecentPlaceContentList();
			this.refreshRecentTextContentList();
		}

		Shark.set({
			recentContentList: [],
		});
	}

	beforeUnload () {
		contentFinderComponent.resetContentFinderSearchField();
		// contentFinderComponent.off("content_selected", this.contentFinderComponent_content_selectedHandler);
	}

	contentFinderComponent_content_selectedHandler (event, data) {
		console.log(this, {event, data});
		// contentType: "image"
		// guid: "19e5a587-23fd-48cb-b300-e056a116c293"
		// title: "Le Cime di Lavaredo"
		let contentManager;
		let destView;

		switch (data.contentType) {
			case "image":
				contentManager = imageContentManager;
				destView = imageContentView;
				break;
			case "place":
				contentManager = placeContentManager;
				destView = placeContentView;
				break;
			case "text":
				contentManager = textContentManager;
				destView = textContentView;
				break;
		}

		contentManager.getByGuid(data.guid)
		.then(getByGuidResponse => {
			console.log({getByGuidResponse});
	
			let currContent;

			switch (data.contentType) {
				case "image":
					currContent = new ImageContent(getByGuidResponse.data[0]);
					break;
				case "place":
					currContent = new PlaceContent(getByGuidResponse.data[0]);
					break;
				case "text":
					currContent = new TextContent(getByGuidResponse.data[0]);
					break;
			}
	
			contentFinderComponent.resetContentFinderSearchField();
			Shark.set({
				currContent,
			});

			Shark.openPage(destView, { urlSearchParams: { coguid: currContent.guid} });
		});
	}

	editContent (contentGuid) {
		waitBoxComponent.open();

		const currContent = Utils.safp(Shark.$store.recentContentList, "guid", contentGuid);

		if (currContent) {
			Shark.set({
				currContent,
			});

			let destView;

			switch (currContent.type) {
				case "image":
					destView = imageContentView;
					break;
				case "place":
					destView = placeContentView;
					break;
				case "text":
					destView = textContentView;
					break;
			}

			Shark.openPage(destView, {urlSearchParams: { coguid: currContent.guid } });
		}
	}

	editContentBtn_clickHandler (event, data) {
		if (data.guid) {
			this.editContent(data.guid);
		}
	}

	init () {
		this.addComponents([contentFinderComponent, mainNavComponent, newContentTypeModalComponent, waitBoxComponent]);

		Shark.set({
			recentContentList: [],
		});
	}

	refreshRecentImageContentList () {
		imageContentManager.getList({ range: this.recentRange, sort: this.recentSort })
		.then(response => {
			const imageContentList = Shark.getInstanceList(ImageContent, response.data);
			this.updateRecentContentList(imageContentList);
		});
	}

	refreshRecentPlaceContentList () {
		placeContentManager.getList({ range: this.recentRange, sort: this.recentSort })
		.then(response => {
			const placeContentList = Shark.getInstanceList(PlaceContent, response.data);
			this.updateRecentContentList(placeContentList);
		});
	}

	refreshRecentTextContentList () {
		textContentManager.getList({ range: this.recentRange, sort: this.recentSort })
		.then(response => {
			const textContentList = Shark.getInstanceList(TextContent, response.data);
			this.updateRecentContentList(textContentList);
		});
	}

	updateRecentContentList (contentListToAdd) {
		const recentContentList = [...Shark.$store.recentContentList, ...contentListToAdd];

		recentContentList.sort((a, b) => {
			if (a.updatedAt > b.updatedAt) {
				return -1;
			}
			else if (a.updatedAt < b.updatedAt) {
				return 1;
			}
		});

		Shark.set({
			recentContentList,
		});
	}
}

const dashboardView = new DashboardView();

Shark.registerView(dashboardView);

export default dashboardView;
